import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import {
  GET_USER_CONTRIBUTORS_QUERY_KEY,
  GET_CONTRIBUTOR_SUMMARY_QUERY_KEY,
} from '@/state/queries/contributors/user-contributors.ts';
import type { PatchUserContributorDto } from '@/types/dtos/contributors/request/patch-user-contributor.dto';

export const usePatchUserContributorMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (patchUserContributorData: PatchUserContributorDto) => {
      const token = await getToken();
      return patchUserContributor(patchUserContributorData, token ?? '');
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [GET_USER_CONTRIBUTORS_QUERY_KEY] }),
        // Invalidate all contributor summary queries since userContributorId might not map directly to contributorId
        queryClient.invalidateQueries({ queryKey: [GET_CONTRIBUTOR_SUMMARY_QUERY_KEY] }),
      ]);
    },
  });
};

const patchUserContributor = async (patchUserContributorData: PatchUserContributorDto, token: string) => {
  const { userContributorId, ...rest } = patchUserContributorData;
  const url = `${import.meta.env.VITE_API_URL}/user-contributors/${userContributorId}`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body: rest, token });
};

export default usePatchUserContributorMutation;
